import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Scaffold from "./components/layout/Scaffold";
import { ToastProvider } from './context/ToastContext';

import LoginPage from './pages/LoginPage';
import ConfirmUser from "./pages/ConfirmUser";
import ResetPasswordPage from "./pages/ResetPassword";
import SignupBusinessPage from "./pages/SignupBusinessPage";
import VerificationCodePage from "./pages/VerificationCodePage";
import CreateStore from "./pages/CreateStore";
import CreateProductItem from "./pages/CreateProductItem";
import EditProductItem from "./pages/EditProductItem";
import ItemDetails from "./pages/ItemDetails";
import CreateCatalogs from "./pages/CreateCatalogs";
import CreateCategories from "./pages/CreateCategories";
import CreatePackageItem from "./pages/CreatePackageItem";
import ProductCatalogs from "./pages/ProductCatalogs";
import ImportData from "./pages/ImportData";
import BranchManagement from "./pages/BranchManagement";
import EditStore from "./pages/EditStore";
import StaffToStore from "./pages/StaffToBranch";
import DiscountManager from "./pages/DiscountManager";
import CustomerManagement from "./pages/CustomerManagement";
import AccountingReports from "./pages/AccountingReports";
import CustomerLedgerReport from "./pages/CustomerLedgerReport";
import NewCustomerDetails from "./pages/NewCustomerDetails";
import GroupMemberManager from "./pages/GroupMemberManager";
import NewAccounting from "./pages/NewAccounting";
import NewAccount from "./pages/NewAccount";
import NewJournalEntry from "./pages/NewJournalEntry";
import AccountType from "./pages/AccountType";
import MappingManager from "./pages/MappingManager";
import AccountDetailsPage from "./pages/AccountDetails";
import AccountLedgerPage from "./pages/AccountLedgerPage";
import EditAccount from "./pages/EditAccount";
import TransactionCorrectionManager from "./pages/TransactionCorrectionManager";
import VendorManagement from "./pages/VendorManagement";
import PurchaseOrderManagement from "./pages/PurchaseOrderManagement";
import VendorPurchaseOrders from "./pages/VendorPurchaseOrders";
import VendorGoodsReceiptWithoutPayment from "./pages/VendorGoodsReceiptWithoutPayment";
import EditVendorGoodsReceiptWithoutPayment from "./pages/EditVendorGoodsReceiptWithoutPayment";
import ReturnToVendor from "./pages/ReturnToVendor";
import FastTrackRestock from "./pages/FastTrackRestock";
import GoodsReceiptApproval from "./pages/GoodsReceiptApproval";
import Users from "./pages/Users";
import UserProfile from "./pages/UserProfile";
import NewStaffMember from "./pages/NewStaffMember";
import InventoryTransferManager from "./pages/InventoryTransferManager";
import Inventory from "./pages/Inventory";
import InventoryLots from "./pages/InventoryLots";
import LedgerSummaryReport from "./pages/LedgerSummaryReport";
import NewTrialBalanceReport from "./pages/NewTrialBalanceReport";
import VendorSubledgerReport from "./pages/VendorSubledgerReport";
import GeneralJournalReport from "./pages/GeneralJournalReport";
import NewStockHistory from "./pages/NewStockHistory";
import CustomerList from "./pages/CustomerList";
import EndOfDaySalesReport from "./pages/EndOfDaySalesReport";
import SalesPerformanceReport from "./pages/SalesPerformanceReport";
import AccountLedgerReport from "./pages/AccountLedgerReport";
import InventoryValuationDashboard from "./pages/InventoryValuationDashboard";
import GoodsReceiptHistory from "./pages/GoodsReceiptHistory";
import ExpenseReport from "./pages/ExpenseReport";
import SalesReport from "./pages/SalesReport";
import NewPNLReport from "./pages/NewPNLReport";
import InventoryClosingReport from "./pages/InventoryClosingReport";
import Invoices from "./pages/Invoices";
import NewInvoice from "./pages/NewInvoice";
import Receipts from "./pages/Receipts";
import NewReceipt from "./pages/NewReceipt";
import PointOfSale from "./pages/PointOfSale";
import PaymentsReceived from "./pages/PaymentsReceived";
import ReceivePayment from "./pages/ReceivePaymen";
import MainDashboard from "./pages/Dashboard";
import InvoiceDetails from "./pages/InvoiceDetails";
import ExpenseLogging from "./pages/Expenses";

function App() {
	return (
		<Router>
			<ToastProvider>
				<Routes>
					<Route path="/" element={<LoginPage />} />
					<Route path="/login" element={<LoginPage />} />
					<Route path="/login-verification" element={<VerificationCodePage />} />
					<Route path="/signup-business" element={<SignupBusinessPage />} />
					<Route path="/confirmuser/:salt" element={<ConfirmUser />} />
					<Route path="/change-password/:salt" element={<ResetPasswordPage />} />
					<Route path="/*" element={<Scaffold />}>
						<Route path="dashboard">
							<Route index element={<MainDashboard />} />
						</Route>
						<Route path="branches">
							<Route index element={<BranchManagement />} />
							<Route path="create" element={<CreateStore />} />
							<Route path="edit" element={<EditStore />} />
							<Route path="staff-to-branch" element={<StaffToStore />} />
							<Route path="manage-discount" element={<DiscountManager />} />
						</Route>
						<Route path="import-data" element={<ImportData />} />
						<Route path="catalog">
							<Route index element={<ProductCatalogs />} />
							<Route path="create-item" element={<CreateProductItem />} />
							<Route path="edit-item" element={<EditProductItem />} />
							<Route path="item-details" element={<ItemDetails />} />
							<Route path="create-catalogs" element={<CreateCatalogs />} />
							<Route path="create-categories" element={<CreateCategories />} />
							<Route path="create-package" element={<CreatePackageItem />} />
						</Route>
						<Route path="accounting">
							<Route index element={<NewAccounting />} />
							<Route path="coa" element={<NewAccounting />} />
							<Route path="new-account" element={<NewAccount />} />
							<Route path="new-journal-entry" element={<NewJournalEntry />} />
							<Route path="accounttype" element={<AccountType />} />
							<Route path="mapping-manager" element={<MappingManager />} />
							<Route path="details" element={<AccountDetailsPage />} />
							<Route path="ledger" element={<AccountLedgerPage />} />
							<Route path="edit" element={<EditAccount />} />
							<Route path="transactions" element={<TransactionCorrectionManager />} />
							<Route path="expenses" element={<ExpenseLogging />} />
						</Route>
						<Route path="sales">
							<Route index element={<PointOfSale />} />
							<Route path="pos" element={<PointOfSale />} />
							<Route path="customers" element={<CustomerManagement />} />
							<Route path="customers/new" element={<NewCustomerDetails />} />
							<Route path="group/members" element={<GroupMemberManager />} />
							<Route path="invoices" element={<Invoices />} />
							<Route path="invoices/new" element={<NewInvoice />} />
							<Route path="discounts" element={<DiscountManager />} />
							<Route path="receipts" element={<Receipts />} />
							<Route path="receipts/new" element={<NewReceipt />} />
							<Route path="payments" element={<PaymentsReceived />} />
							<Route path="invoices/receive-payment" element={<ReceivePayment />} />
							<Route path="invoices/view" element={<InvoiceDetails />} />
						</Route>
						<Route path="reports">
							<Route index element={<AccountingReports />} />
							<Route path="customer-list" element={<CustomerList />} />
							<Route path="customer-report" element={<CustomerLedgerReport />} />
							<Route path="general-ledger-report" element={<LedgerSummaryReport />} />
							<Route path="general-ledger-trial-balance" element={<NewTrialBalanceReport />} />
							<Route path="vendor-ledger-report" element={<VendorSubledgerReport />} />
							<Route path="general-journal-report" element={<GeneralJournalReport />} />
							<Route path="new-stock-history" element={<NewStockHistory />} />
							<Route path="eod-sales-report" element={<EndOfDaySalesReport />} />
							<Route path="sales-performance" element={<SalesPerformanceReport />} />
							<Route path="account-ledger-report" element={<AccountLedgerReport />} />
							<Route path="inventory-valuation-report" element={<InventoryValuationDashboard />} />
							<Route path="goods-receipt-history" element={<GoodsReceiptHistory />} />
							<Route path="expense-report" element={<ExpenseReport />} />
							<Route path="sales-report" element={<SalesReport />} />
							<Route path="profit-and-loss" element={<NewPNLReport />} />
							<Route path="inventory-closing-report" element={<InventoryClosingReport />} />
						</Route>
						<Route path="vendor">
							<Route index element={<VendorManagement />} />
							<Route path="list" element={<VendorManagement />} />
							<Route path="create-purchase-orders" element={<PurchaseOrderManagement />} />
							<Route path="view-purchase-orders" element={<VendorPurchaseOrders />} />
							<Route path="vendor-goods-receipt" element={<VendorGoodsReceiptWithoutPayment />} />
							<Route path="edit-vendor-goods-receipt" element={<EditVendorGoodsReceiptWithoutPayment />} />
							<Route path="return-to-vendor" element={<ReturnToVendor />} />
							<Route path="fast-restock" element={<FastTrackRestock />} />
							<Route path="approve-vendor-goods-receipt" element={<GoodsReceiptApproval />} />
						</Route>
						<Route path="inventory">
							<Route index element={<Inventory />} />
							<Route path="index" element={<Inventory />} />
							<Route path="inventory-transfer" element={<InventoryTransferManager />} />
							<Route path="lots" element={<InventoryLots />} />
						</Route>
						<Route path="settings">
							<Route index element={<Users />} />
							<Route path="user-profile" element={<UserProfile />} />
							<Route path="invite-staff" element={<NewStaffMember />} />
						</Route>
					</Route>
				</Routes>
			</ToastProvider>
		</Router>
	)
}

export default App;